export default "__VITE_ASSET__vWxIyclO__"